module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-projects"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Ordre " + _vm._s(_vm.data.case_number) + " - " + _vm._s(_vm.data.customer.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'budget_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2a91a18a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a91a18a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/enterprise/components/subProjects.vue
// module id = 805
// module chunks = 0